import PauseCircleFilledRoundedIcon from '@mui/icons-material/PauseCircleFilledRounded';
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded';
import { Stack } from '@mui/material';
import React, { FC, SyntheticEvent, useState } from 'react';
import ReactPlayer from 'react-player';

interface VideoNotePreviewProps {
  videoSrc: string;
  playerHeight?: number | string;
  playerWidth?: number | string;
}

const VideoNotePreview: FC<VideoNotePreviewProps> = ({
  videoSrc,
  playerHeight = 200,
  playerWidth = 200,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = (e: SyntheticEvent) => {
    e.stopPropagation();

    setIsPlaying((prev) => !prev);
  };

  const onVideoEnd = () => {
    setIsPlaying(false);
  };

  return (
    <Stack
      sx={{
        position: 'relative',
        borderRadius: '50%',
        overflow: 'hidden',
        height: playerHeight,
        width: playerWidth,
        ':hover': {
          '.pauseButton': {
            display: 'block',
          },
        },
      }}
    >
      <ReactPlayer
        url={videoSrc}
        width={playerWidth}
        height={playerHeight}
        playing={isPlaying}
        onEnded={onVideoEnd}
      />

      {!isPlaying && (
        <PlayCircleRoundedIcon
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '48px',
            cursor: 'pointer',
          }}
          onClick={togglePlay}
        />
      )}

      {isPlaying && (
        <PauseCircleFilledRoundedIcon
          className="pauseButton"
          sx={{
            display: 'none',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '48px',
            cursor: 'pointer',
          }}
          onClick={togglePlay}
        />
      )}
    </Stack>
  );
};

export default VideoNotePreview;
